import { AUTH_ACTIONS, initialAuthState } from './auth.types'

/**
 *
 * @param {import('./auth.types').AuthSlice} state
 * @param {import('./auth.types'.AuthAction)} action
 * @returns
 */
export function authReducer(state = initialAuthState, { type, payload }) {
  switch (type) {
    case AUTH_ACTIONS.SET_AUTH_STATUS:
      return { ...state, status: payload }

    case AUTH_ACTIONS.SET_AUTH_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case AUTH_ACTIONS.SET_AUTH_TASK:
      return { ...state, task: payload }

    case AUTH_ACTIONS.SET_AUTH_TOKEN:
      return { ...state, token: payload }

    case AUTH_ACTIONS.SET_REDIRECT_URI:
      return { ...state, redirectUri: payload }

    case AUTH_ACTIONS.SET_CURRENT_ADMIN_ID:
      return { ...state, currentAdminId: payload }

    case AUTH_ACTIONS.SET_TOKEN_VERIFIED:
      return { ...state, tokenVerified: payload }

    case AUTH_ACTIONS.CLEAR_AUTH_ERRORS:
      return { ...state, errors: [] }

    case AUTH_ACTIONS.CLEAR_AUTH_TASK:
      return { ...state, task: null }

    case AUTH_ACTIONS.CLEAR_AUTH_TOKEN:
      return { ...state, token: '' }

    case AUTH_ACTIONS.CLEAR_AUTH:
      return { ...initialAuthState, status: 'idle', currentAdminId: null, tokenVerified: false }

    case AUTH_ACTIONS.OVERWRITE_AUTH:
      return { ...initialAuthState, ...payload }

    case AUTH_ACTIONS.UPDATE_AUTH:
      return { ...state, ...payload }

    default:
      return state
  }
}
